import React, { FC, useCallback } from 'react';
import { Dialog } from '@rbx/ui';
import unifiedLoggerClient from '@modules/eventStream/implementations/unifiedLoggerClient';
import DocsAssistantEvent from '@modules/eventStream/enum/DocsAssistantEvent';
import { useLocalization, useTranslation } from '@rbx/intl';
import TDialogTemplate from '@modules/miscellaneous/common/components/TDialogTemplate';
import { useIsAuthenticated } from '../context/IsAuthenticatedProvider';

const LoginRequiredDialog: FC<React.PropsWithChildren> = () => {
  const { translate } = useTranslation();
  const { locale } = useLocalization();
  const { login } = useIsAuthenticated();
  const onCloseNoOp = () => null;
  const onLogin = useCallback(async () => {
    unifiedLoggerClient.logClickEvent({
      eventName: DocsAssistantEvent.UserClickedLoginRequiredDialogLoginButton,
      parameters: {
        locale: locale ? String(locale) : '',
      },
    });
    login();
  }, [locale, login]);
  return (
    <Dialog open maxWidth='XLarge' onClose={onCloseNoOp}>
      <TDialogTemplate
        variant='center'
        title={translate('Dialog.LoginHeaderText')}
        confirmText={translate('Button.LogIn')}
        onConfirm={onLogin}
      />
    </Dialog>
  );
};

export default LoginRequiredDialog;
